<template>
    <div class="page">
        <div class="header width-container">
            <div class="logo">
                <img src="logo.svg" height="48" class="logo"/>
            </div>
            <div v-if="$store.state.user" class="user" @click="logout">
                <div class="logout">Logout</div>
            </div>
        </div>

        <div class="dashboard width-container">
            <section class="side-panel container">
                <div class="section-title">&nbsp;</div>
                <div class="content">

                    <div class="side-panel-section" v-if="customers.length > 1">
                        <div class="section-title">Filters</div>
                        <div class="row" v-if="customers.length > 1">
                            <div class="title">
                                Customer
                                <div class="clear" v-if="filters['customer']['value']"
                                     @click="filters['customer']['value'] = undefined">
                                    x
                                </div>
                            </div>
                            <div class="filter-options">
                                <template v-for="c in customers">
                                    <label :for="`c-${c}`" :key="c">
                                        {{ c }} <input :id="`c-${c}`" v-model="filters['customer']['value']"
                                                       type="radio"
                                                       :value="c"/>
                                    </label>
                                </template>
                            </div>
                        </div>

                        <div class="row" v-if="hoursReady">
                            <div class="title">
                                Is open?
                                <div class="clear" v-if="filters['currentlyOpen']['value'] !== undefined"
                                     @click="filters['currentlyOpen']['value'] = undefined">
                                    x
                                </div>
                            </div>
                            <div class="filter-options">
                                <template v-for="opt in ['yes','no']">
                                    <label :for="`c-${opt}`" :key="opt">
                                        {{ opt }} <input :id="`c-${opt}`" v-model="filters['currentlyOpen']['value']"
                                                         type="radio"
                                                         :value="opt === 'yes'"/>
                                    </label>
                                </template>

                            </div>
                        </div>
                    </div>

                    <div class="side-panel-section">
                        <div class="section-title">Display settings</div>

                        <div class="row">
                            <div class="title">Store name</div>
                            <div class="setting">
                                <input type="text" v-model="storeIdentifier" placeholder="store name"
                                       data-lpignore="true"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="title">
                                Social distance
                            </div>

                            <div v-for="locale in $i18n.availableLocales" :key="locale" class="setting checkbox">
                                <label :key="locale+'-label'" class="locale">
                                    {{ locale }} <input type="checkbox" @change.prevent.stop="toggleLocale(locale)"
                                                        :checked="selectedIndex(locale) !== -1" :value="locale"
                                                        data-lpignore="true"
                                                        v-model="checkedLocales">
                                </label>

                                <input type="text" placeholder="2 meter" v-if="selectedIndex(locale) !== -1"
                                       data-lpignore="true"
                                       :key="locale+'-distance'"
                                       v-model="selectedLocales[selectedIndex(locale)].distance"/>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="container" style="margin-bottom:2em;">
                <div class="section-title">Sites</div>
                <div class="grid">
                    <store-item v-for="(store,index) in sorted" :store="store"
                                :key="`store-${store.id}-${index}`"
                                @select="selectStore"/>
                </div>
            </section>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import StoreItem from './StoreItem';

export default {
  name: 'index',
  components: {StoreItem},
  data() {
    return {
      items: [],

      data: {
        customers: []
      },

      filters: {
        customer: {type: 'number', value: undefined},
        currentlyOpen: {type: 'bool', value: undefined},
      },

      checkedLocales: [],
      selectedLocales: [],
      storeIdentifier: this.$store.getters['storeName'],
      hoursReady: false
    };
  },

  mounted() {
    this.selectedLocales = this.$store.getters['i18n/selected'];
    this.selectedLocales.forEach(l => this.checkedLocales.push(l.locale));
    this.fetch();
  },

  computed: {
    customers() {
      return [...new Set(this.items.map(i => i.customer))];
    },

    filteredStores() {
      let items = this.items;
      for (let k in this.filters) {
        if (this.filters[k].type === 'number' && this.filters[k].value) {
          items = items.filter(i => i[k] === this.filters[k].value);
        }

        if (this.filters[k].type === 'bool' && this.filters[k].value !== undefined) {
          if (k === 'currentlyOpen') {
            items = items.filter(i => this.filters[k].value ? this.openIds.includes(i.id) : !this.openIds.includes(i.id));
          }
        }
      }
      return items;
    },

    sorted() {
      // Wait for fetches, prevents 'jumping' of cards
      if (this.hoursReady) {
        // Only sort when there's a difference between open and closed stores
        if (this.openIds.length < this.items.length) {
          // return items;
          return this.filteredStores.sort((a, b) => {
            return this.openIds.indexOf(b.id) - this.openIds.indexOf(a.id);
          });
        } else {
          return this.filteredStores;
        }
      }

      return [];
    },

    openIds() {
      // TODO: add regular update
      let items = [];
      if (this.hoursReady) {
        let now = moment();

        this.items.forEach((item) => {

          if (item.hours) {
            let open = moment(item.hours.open);
            let close = moment(item.hours.close);
            if (now.isSameOrAfter(open) && now.isSameOrBefore(close)) {
              items.push(item.id);
            }
          }
        });
      }
      return items;
    }
  },

  methods: {

    fetch() {
      // User data
      axios.get(`${process.env.VUE_APP_API_BASE}/a/user?api_key=${this.$store.getters.key}&fields=customer`)
        .then((res) => {
          this.data.customers = res.data.customers;
        });

      // Site data
      axios.get(`${process.env.VUE_APP_API_BASE}/sites?api_key=${this.$store.getters.key}&fields=id,name,customer,user_dashboard_features,analytics_dashboard_start_date&limit=1000`)
        .then((res) => {
          // Filter sites based on available feature 'occupancy'
          this.items = res.data.results.filter(s => s.user_dashboard_features.includes('occupancy'));
          this.ready = true;
        })
        .then(() => {
          this.getAllOpeningHours();
        });
    },

    getAllOpeningHours() {
      let count = 0;
      this.items.forEach((item) => {
        axios.get(`${process.env.VUE_APP_API_BASE}/sites/${item.id}/simple-opening-hours?api_key=${this.$store.getters.key}`)
          .then((res) => {
            item.hours = res.data[0];
            count++;
          })
          .then(() => {
            if (count === this.items.length) {
              this.hoursReady = true;
            }
          });
      });
    },

    selectedIndex(locale) {
      return this.selectedLocales.findIndex((l) => {
        return l.locale === locale.toLowerCase();
      });
    },

    toggleLocale(selected) {
      const index = this.selectedIndex(selected);
      if (index === -1) {
        this.selectedLocales.push({locale: selected, distance: ''});
      } else {
        if (this.selectedLocales.length > 1) {
          this.selectedLocales.splice(index, 1);
        } else {
          this.$nextTick(() => {
            this.checkedLocales.push(this.selectedLocales[0].locale);
          });
          this.$notify.error('At least 1 language should be selected');
        }
      }
    },

    selectStore(id) {
      this.$store.dispatch('SET_STORE_NAME', this.storeIdentifier);
      this.$store.dispatch('i18n/SET', this.selectedLocales)
        .then(() => {
          this.$router.push({name: 'store', params: {id: id}});
        });
    },

    logout() {
      localStorage.removeItem(process.env.VUE_APP_COOKIE_NAME);
      window.location = '/';
    }
  }
};
</script>

<style scoped lang="scss">
.page {
    height: 100%;
    font-weight: 500;
    overflow-y: scroll;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1em !important;

    .user {
        padding: 1em;
        cursor: pointer;

        .logout {
            text-align: right;
            text-decoration: underline;
            opacity: .6;
            transition: opacity .3s;
        }

        &:hover {
            .logout {
                opacity: 1;
            }
        }
    }
}

.width-container {
    margin: 0 auto;
    max-width: calc(1920px - 280px);
}

.dashboard {
    display: flex;
    text-align: left;

    .side-panel {
        flex: 1;
        flex-grow: 0;
        margin-right: 16px;
        max-width: 260px;

        .content {
            background: #FFF;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            border-radius: .5em;
            padding: 1em 1.25em;

            .section-title {
                border-bottom: 1px solid #e0e0e0;
                padding-bottom: .25em;
            }
        }

        .row {
            margin-bottom: 1em;
            padding: 1em .5em;
            border-radius: .5em;
            font-size: .8em;


            &:last-child {
                margin-bottom: 0;
            }

            .title {
                margin-bottom: .5em;
                display: flex;
                justify-content: space-between;
            }

            .setting {
                max-width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: .5em;
                height: 2.25em;

                &:last-child {
                    margin-bottom: initial;
                }

                &.checkbox {
                    .locale {
                        width: 70px;
                        text-transform: uppercase;

                        margin-right: 16px;
                    }
                }

                input {
                    transition: all cubic-bezier(.25, .8, .25, 1) .3s;
                    border: none;
                    background: #fafafa;
                    box-shadow: var(--shadow-inset);
                    border-radius: 8px;
                    line-height: 30px;
                }

                input[type=text] {
                    padding: .5em;
                    flex-grow: 0;
                    width: 100%;
                    color: #4e4e4e;
                }
            }
        }

        .filter {
            .title {
                display: flex;
                justify-content: space-between;
            }

            .filter-options {
                display: flex;
                flex-flow: column;
            }
        }

        &.container {
            padding: 1em 0;
        }
    }

    .container {
        flex: 2;
        padding: 1em;
        border-radius: .5em;
        position: relative;

        .grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            //grid-column-gap: 1.5em;
            grid-gap: 1.5em;
            //grid-row-gap: 1.5em;
        }

        .section-title {
            background: inherit;
            margin: 1.75em .5em .5em;

            &:first-child {
                margin-top: .5em;
            }
        }
    }
}

.slide-enter-active, .slide-leave-active {
    position: relative;
    transition: all ease-in-out .5s;
}

.slide-enter-to, .slide-leave {
    transform: translateY(0);
    opacity: 1;
}

.slide-enter, .slide-leave-to {
    transform: translateY(50px);
    opacity: 0;
}

.clear {
    cursor: pointer;
}

@media only screen and (max-width: 1640px) {
    .header {
        margin: 0 8px;
    }
    .dashboard .side-panel {
        margin-left: 16px;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1280px) {
    .dashboard {
        .container {
            .grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }
    }
}

@media only screen and (max-width: 1024px) {
    .dashboard {
        .container {
            .grid {
                grid-template-columns: repeat(1, 1fr);
            }
        }
    }
}

@media only screen and (max-width: 1024px) {
    .dashboard {
        flex-flow: column;

        .side-panel {
            max-width: initial;
        }
    }
}

</style>